(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["partial_announcement-bar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    function tryInit() {
      if (!window.Marquee3k) return false;
      if (!document.querySelector('.marquee')) return false;
      Marquee3k.init({ selector: 'marquee' });
      return true;
    }

    // With `defer`, this should usually work immediately.
    if (tryInit()) return;

    // Single short retry in case the vendor script arrives slightly later.
    setTimeout(tryInit, 200);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partial_related-products"]) return;
  try {
    
  const initRelatedProducts = () => {
    const productRecommendationsSection = document.querySelector('.related-products-container');
    if (!productRecommendationsSection) return;

    if (productRecommendationsSection.querySelector('.related-products-intent')) return;

    const baseUrl = productRecommendationsSection.dataset.baseUrl;
    if (!baseUrl) return;

    const intents = ['related', 'complementary'];

    Promise.all(
      intents.map((intent) =>
        fetch(`${baseUrl}&intent=${intent}`)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            return html.querySelector(`.related-products-intent[data-intent="${intent}"]`);
          })
      )
    )
      .then((intentBlocks) => {
        const validBlocks = intentBlocks.filter((block) => block && block.innerHTML.trim().length);
        if (!validBlocks.length) return;

        productRecommendationsSection.innerHTML = '';
        validBlocks.forEach((block) => {
          productRecommendationsSection.appendChild(block);
        });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRelatedProducts, { once: true });
  } else {
    initRelatedProducts();
  }

  } catch(e) { console.error(e); }
})();
})();
